<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NI6NZm/tc-custom/9781446350997.jpg?1725288188962" alt="This image is the cover for the book Just the Right Words"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Just the Right Words
      </h1>
      <p class="bookDescription body article font2">
        <b>Find just the right words for your card with this unique collection of original sentiments and verses, plus motifs to add embellishment.</b><br/><br/>From witty and poignant one-liners to inspirational and heart-felt verses, this collection is guaranteed to bring joy to your heart and a smile to your face.<br/><br/>In addition, there are also numerous copyright-free motifs sprinkled throughout the occasion-themed chapters to add extra-special embellishment to your cards.<br/><br/>Find the right words for any occasion including:BirthdaysAnniversariesChristmasValentine’s DayLove &amp; FriendshipNew HomeWeddingsGraduationsAcross the MilesNew BabySorryThank YouEaster &amp; ReligiousChristeningsMother’s DayFather’s DayGood LuckNew JobGet WellSympathy<br/><br/>Whatever you want to say, say it with the help of this charming and entertaining book.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judith Wibberley
      </h2>
      
      <p class="authorDescription body article">Judith Wibberley ran a craft center for many years and now sells creative craft supplies online. Her first booklet of verses was a hit with UK crafters. She currently lives in Devon, in the United Kingdom.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      David & Charles
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2875ea3c